import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-bar',
  standalone: true,
  imports: [CommonModule],

  template: `
    <!-- Top progress bar -->
    <div
      *ngIf="isLoading"
      class="position-fixed top-0 start-0 w-100 loading-bar-track">

      <div
        class="h-100 loading-bar-fill"
        [style.width.%]="progress">
      </div>

    </div>

    <!-- Center overlay -->
    <div
      *ngIf="isLoading"
      class="position-fixed top-0 start-0 w-100 h-100
             d-flex align-items-center justify-content-center
             loading-overlay">

      <div
        class="position-relative d-flex align-items-center
               justify-content-center loading-icon-wrap">

        <!-- Outer pulsing ring -->
        <div
          class="position-absolute top-0 start-0 w-100 h-100
                 rounded-circle ping-ring">
        </div>

        <!-- Spinning ring -->
        <div
          class="position-absolute top-0 start-0 w-100 h-100
                 rounded-circle spin-ring">
        </div>

        <!-- Percentage -->
        <div class="loading-percentage">
          {{ progress }}%
        </div>

      </div>
    </div>
  `,

  styles: [`

    .loading-bar-track {
      height: 3px;
      z-index: 9999;
      background: transparent;
      overflow: hidden;
    }

    .loading-bar-fill {
      background-color: #3b82f6;
      transition: width 0.3s ease;
    }

    .loading-overlay {
      z-index: 9998;
      background-color: rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
    }

    .loading-icon-wrap {
      width: 6rem;
      height: 6rem;
      background: transparent;
    }

    .ping-ring {
      border: 4px solid rgba(96, 165, 250, 0.4);
      background: transparent;
      animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
    }

    @keyframes ping {
      0% {
        transform: scale(1);
        opacity: 1;
      }

      75%, 100% {
        transform: scale(1.6);
        opacity: 0;
      }
    }

    .spin-ring {
      border: 4px solid transparent;
      border-top-color: #3b82f6;
      border-right-color: #3b82f6;
      background: transparent;
      animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }

    .loading-percentage {
      z-index: 10;
      font-size: 18px;
      font-weight: 600;
      color: #3b82f6;
    }

  `]
})
export class LoadingBarComponent implements OnChanges, OnDestroy {

  @Input() isLoading = false;

  progress = 0;

  private timer?: ReturnType<typeof setInterval>;

  ngOnChanges(changes: SimpleChanges): void {

    if (!changes['isLoading']) {
      return;
    }

    if (this.isLoading) {
      this.startProgress();
    } else {
      this.completeProgress();
    }
  }

  private startProgress(): void {

    this.clearTimer();

    this.progress = 0;

    this.timer = setInterval(() => {

      // Don't reach 100% until API actually finishes
      if (this.progress < 90) {

        const increase = Math.floor(Math.random() * 5) + 1;

        this.progress = Math.min(
          this.progress + increase,
          90
        );
      }

    }, 300);
  }

  private completeProgress(): void {

    this.clearTimer();

    // API finished
    this.progress = 100;

    setTimeout(() => {
      this.progress = 0;
    }, 300);
  }

  private clearTimer(): void {

    if (this.timer) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }
}